/**
 * @fileoverview Defines constants used by the Listings Launch UI.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {ListingsLaunchStep} from '/src/com/yext/listingslaunchstorm/js/data/listingslaunchstep';
import {getLayoutHeaderProps} from '/src/com/yext/listingslaunchstorm/js/util/layoutheader';

export const ExternalAccountsLayoutHeader = getLayoutHeaderProps(
  yext.msg('Link Your Google Business Profile Accounts'),
  yext.msg('Link your Google Business Profile account. Linking your account allows you to manage your Google Business Profile listings through this platform. If you don’t have a Google account, you can create one on Google.'),
);

export const MatchEntityLayoutHeader = getLayoutHeaderProps(
  yext.msg('Match Entities For Google Business Profile'),
  yext.msg('If you have an existing Google Business Profile listing, please select it below. Otherwise, create a new listing.'),
);

export const VerifyEntityLayoutHeader = getLayoutHeaderProps(
  yext.msg('Verify Your Google Business Profile'),
  (<div>
    <p dangerouslySetInnerHTML=
      {{
        __html: yext.msg('Any change to your listing data on Google Business Profile could require reverification of your location.'),
      }}
    />
  </div>),
);

export function getLaunchStepHeader(launchStep) {
  switch (launchStep) {
    case ListingsLaunchStep.PUBLISHER_SETUP:
      return ExternalAccountsLayoutHeader;
    case ListingsLaunchStep.MATCH_ENTITY:
      return MatchEntityLayoutHeader;
    case ListingsLaunchStep.VERIFICATION:
      return VerifyEntityLayoutHeader;
  }
}

export function getLaunchStepNextButtonText(launchStep) {
  switch (launchStep) {
    case ListingsLaunchStep.PUBLISHER_SETUP:
      return yext.msg('Continue to Matching');
    case ListingsLaunchStep.MATCH_ENTITY:
      return yext.msg('Continue to Verification');
    case ListingsLaunchStep.VERIFICATION:
      return yext.msg('Continue');
  }
}
